var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMjTitleBelow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 51,
    viewBox: "0 0 386 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.087 42.1932V3.43713H305.151V50.5H324.288V42.1932H316.087Z",
    fill: "#0E081A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M294.962 42.1932V28.3521H292.227V8.97145H289.491V3.43713H273.09V11.7439H270.355V28.3521H267.619V44.9604H264.884V50.4947H278.555V42.1879H284.021V50.4947H297.692V44.9604H294.957V42.1932H294.962ZM278.561 17.2782H284.026V33.8865H278.561V17.2782Z",
    fill: "#0E081A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4602 42.1932V50.5H91.6609V42.1932H83.4602Z",
    fill: "#0E081A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.317 8.97145H147.582V6.20429H144.847V3.43713H131.175V6.20429H128.44V8.97145H125.704V11.7386H122.969V42.1879H125.704V44.9551H128.44V47.7222H131.175V50.4894H144.847V47.7222H147.582V44.9551H150.317V42.1879H153.053V11.7439H150.317V8.97145ZM133.916 42.1932V11.7439H142.116V42.1932H133.916Z",
    fill: "#0E081A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M382.939 6.20429V3.43713H358.336V50.5H369.272V28.3521H374.738V50.5H385.674V28.3521H382.939V22.8178H385.674V6.20429H382.939ZM374.738 20.0454H369.272V8.97145H374.738V20.0454Z",
    fill: "#0E081A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M331.741 3.43713V50.5H350.878V42.1932H342.677V28.3521H350.878V20.0454H342.677V11.7439H350.878V3.43713H331.741Z",
    fill: "#0E081A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M249.23 3.43713V22.8178H246.494V14.5111H243.764V6.20429H241.029V3.43713H230.093V50.5H241.029V28.3521H243.764V36.6589H246.494V47.7328H249.23V50.5H257.431V3.43713H249.23Z",
    fill: "#0E081A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M219.904 3.43713H195.302V50.5H206.238V28.3521H211.704V50.5H222.64V28.3521H219.904V22.8178H222.64V6.20429H219.904V3.43713ZM211.704 20.0507H206.238V8.97145H211.704V20.0507Z",
    fill: "#0E081A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2715 3.43713H48.6693V50.5H59.6054V28.3521H65.0708V50.5H76.0069V28.3521H73.2715V22.8178H76.0069V6.20429H73.2715V3.43713ZM65.0708 20.0507H59.6054V8.97145H65.0708V20.0507Z",
    fill: "#0E081A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M176.907 3.43713V42.1932H171.442V3.43713H160.506V44.9604H163.241V47.7328H165.971V50.5H182.378V47.7328H185.108V44.9604H187.843V3.43713H176.907Z",
    fill: "#0E081A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M104.585 3.43713V42.1932H99.1195V50.5H112.786V47.7328H115.521V3.43713H104.585Z",
    fill: "#0E081A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8092 3.43713V17.2782H19.3385V3.43713H2.93701V50.5H13.8731V28.3521H16.6085V50.5H27.5393V28.3521H30.2746V50.5H41.2107V3.43713H24.8092Z",
    fill: "#0E081A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M313.15 39.2561V0.5H302.214V47.5629H321.351V39.2561H313.15Z",
    fill: "#22B7BB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M292.025 39.2561V25.415H289.29V6.03431H286.554V0.5H270.153V8.80677H267.418V25.415H264.682V42.0233H261.947V47.5576H275.618V39.2508H281.084V47.5576H294.755V42.0233H292.02V39.2561H292.025ZM275.624 14.3411H281.089V30.9493H275.624V14.3411Z",
    fill: "#22B7BB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5232 39.2561V47.5629H88.7239V39.2561H80.5232Z",
    fill: "#22B7BB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.38 6.03431H144.645V3.26716H141.91V0.5H128.238V3.26716H125.503V6.03431H122.767V8.80147H120.032V39.2508H122.767V42.0179H125.503V44.7851H128.238V47.5523H141.91V44.7851H144.645V42.0179H147.38V39.2508H150.116V8.80677H147.38V6.03431ZM130.979 39.2561V8.80677H139.179V39.2561H130.979Z",
    fill: "#22B7BB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M380.002 3.26716V0.5H355.399V47.5629H366.335V25.415H371.801V47.5629H382.737V25.415H380.002V19.8807H382.737V3.26716H380.002ZM371.801 17.1082H366.335V6.03431H371.801V17.1082Z",
    fill: "#22B7BB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M328.804 0.5V47.5629H347.941V39.2561H339.74V25.415H347.941V17.1082H339.74V8.80677H347.941V0.5H328.804Z",
    fill: "#22B7BB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M246.293 0.5V19.8807H243.557V11.5739H240.827V3.26716H238.092V0.5H227.156V47.5629H238.092V25.415H240.827V33.7218H243.557V44.7957H246.293V47.5629H254.494V0.5H246.293Z",
    fill: "#22B7BB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M216.967 0.5H192.365V47.5629H203.301V25.415H208.767V47.5629H219.703V25.415H216.967V19.8807H219.703V3.26716H216.967V0.5ZM208.767 17.1135H203.301V6.03431H208.767V17.1135Z",
    fill: "#22B7BB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3345 0.5H45.7323V47.5629H56.6684V25.415H62.1338V47.5629H73.0699V25.415H70.3345V19.8807H73.0699V3.26716H70.3345V0.5ZM62.1338 17.1135H56.6684V6.03431H62.1338V17.1135Z",
    fill: "#22B7BB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M173.97 0.5V39.2561H168.505V0.5H157.569V42.0233H160.304V44.7957H163.034V47.5629H179.441V44.7957H182.171V42.0233H184.906V0.5H173.97Z",
    fill: "#22B7BB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M101.648 0.5V39.2561H96.1825V47.5629H109.849V44.7957H112.584V0.5H101.648Z",
    fill: "#22B7BB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8722 0.5V14.3411H16.4015V0.5H0V47.5629H10.9361V25.415H13.6714V47.5629H24.6022V25.415H27.3376V47.5629H38.2737V0.5H21.8722Z",
    fill: "#22B7BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMjTitleBelow);
export default __webpack_public_path__ + "static/media/MJTitleBelow.989a71f52ac5a8d6aff76fc28e6ba89f.svg";
export { ForwardRef as ReactComponent };